import { ContentBox } from "../../../components/structure/ContentBox";
import { ContentHeader } from "../../../components/structure/ContentHeader";
import { VersionHistory } from "./subcomponents/VersionHistory";
import { TemplateView } from "./subcomponents/TemplateView";
import { EmptyProfile } from "./subcomponents/EmptyProfile";
import React, { useState } from "react";
import { Template, TemplateType } from "../../../../core/entities/template";
import { TemplateProfile } from "../../../../core/entities/templateProfile";
import { BasicDialog } from "../../../components/modal/BasicDialog";
import { ReplacementField } from "../../../../core/entities/replacementField";

export interface TemplateOverview_VM {
    onSelectTemplate: (type: TemplateType, template: Template) => void;
    onMakeDraft: () => void;
    onMakeCopy: (template: Template) => void;
    onEditTemplate: (selectedTemplate: Template) => void;
    typeButtonComponents: React.JSX.Element[];
    selectedProfile: TemplateProfile | undefined;
    selectedTemplate: Template;
    replacementFields: ReplacementField[];
}

export function TemplateOverviewComponent({
    typeButtonComponents,
    selectedProfile,
    onEditTemplate,
    selectedTemplate,
    onSelectTemplate,
    onMakeDraft,
    onMakeCopy,
    replacementFields
}: TemplateOverview_VM) {
    const [isCopyOpen, setIsCopyOpen] = useState<boolean>(false);
    const [isNewOpen, setIsNewOpen] = useState<boolean>(false);

    function handleNewDraftOrPrompt() {
        if (selectedProfile?.draft) {
            setIsNewOpen(true);
            return;
        }

        onMakeDraft();
    }

    function handleMakeCopyOrPrompt() {
        if (selectedProfile?.draft) {
            setIsCopyOpen(true);
            return;
        }

        handleMakeCopy();
    }

    function handleMakeCopy() {
        onMakeCopy(selectedTemplate);
    }

    return (
        <>
            <div className="flex flex-row space-x-40">
                <div className={"flex flex-col flex-[2]"}>
                    <ContentBox className={"animate-fade-in"}>
                        <ContentHeader>Type skabelon</ContentHeader>
                        <div className={"space-y-8"}>
                            {typeButtonComponents}
                        </div>
                    </ContentBox>

                    <ContentBox
                        key={selectedProfile!.type}
                        className={"animate-fade-in"}
                    >
                        <ContentHeader>Versionshistorik</ContentHeader>
                        <VersionHistory
                            onEdit={(template) => onEditTemplate(template)}
                            selected={selectedTemplate}
                            onSelect={(template) =>
                                onSelectTemplate(template.type, template)
                            }
                            profile={selectedProfile!}
                        />
                    </ContentBox>
                </div>

                <ContentBox
                    key={selectedProfile!.type}
                    className={
                        "flex-[3] animate-fade-in min-w-[536px] flex flex-col"
                    }
                >
                    {selectedTemplate ? (
                        <TemplateView
                            onMakeDraft={handleNewDraftOrPrompt}
                            onMakeCopy={handleMakeCopyOrPrompt}
                            onEdit={() => onEditTemplate(selectedTemplate)}
                            selected={selectedTemplate!}
                            replacementFields={replacementFields}
                        />
                    ) : (
                        <EmptyProfile onMakeDraft={onMakeDraft} />
                    )}
                </ContentBox>
            </div>
            <BasicDialog
                description={
                    "Du har en upubliceret kladde. Vil du overskrive denne?"
                }
                title={"Overskriv nuværende kladde"}
                buttonA={{
                    label: "Ja",
                    onClick: handleMakeCopy
                }}
                isOpen={isCopyOpen}
                setIsOpen={setIsCopyOpen}
            />
            <BasicDialog
                description={
                    "Du har en upubliceret kladde. Vil du overskrive denne?"
                }
                title={"Overskriv nuværende kladde"}
                buttonA={{
                    label: "Ja",
                    onClick: onMakeDraft
                }}
                isOpen={isNewOpen}
                setIsOpen={setIsNewOpen}
            />
        </>
    );
}
